import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import ReactGA from 'react-ga'

import store, { history } from './store'
// import registerServiceWorker from './registerServiceWorker'

import App from './App'
import { fetchPositions, handleLinkedinRedirect } from './modules/positions'

// import 'typeface-quattrocento-sans'

import 'bootstrap/dist/css/bootstrap-grid.css'
import 'bootstrap/dist/css/bootstrap.css'

import './index.css'

ReactGA.initialize('UA-118020719-1')
ReactGA.pageview(window.location.pathname + window.location.search)
history.listen(({pathname, search}) => ReactGA.pageview(pathname+search))

fetchPositions()(store.dispatch)
handleLinkedinRedirect(store)

const target = document.querySelector('#root')
render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  target
)
//registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js